import { render, staticRenderFns } from "./StockForm.vue?vue&type=template&id=a9c3a67c&"
import script from "./StockForm.vue?vue&type=script&lang=js&"
export * from "./StockForm.vue?vue&type=script&lang=js&"
import style0 from "./StockForm.vue?vue&type=style&index=0&id=a9c3a67c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports